/**
 * BUSINESS AVATAR — Cerchio con iniziale del nome azienda (uppercase).
 * Riusabile in detail page (size='lg') e in tabelle list (default).
 *
 * Logica di calcolo iniziale + classi CSS (.avatar / .avatar--lg) viene
 * esposta da un solo punto: ogni call-site del progetto la usa via questo
 * componente per garantire coerenza visiva.
 */

// TODO (in futuro ci sarà immagine associata a business e potremo mostrare quella invece dell'iniziale).

interface BusinessAvatarProps {
  name?: string | null;
  /** 'lg' = 40×40 (detail page header). Default = 32×32 (cell tabelle). */
  size?: 'lg';
}

export function BusinessAvatar({ name, size }: BusinessAvatarProps) {
  const initial = (name?.charAt(0) ?? '?').toUpperCase();
  const className = size === 'lg' ? 'avatar avatar--lg' : 'avatar';
  return <div className={className}>{initial}</div>;
}
